import React, { useState } from "react"
import { Wizard } from "react-use-wizard"
import { useForm, FormProvider } from "react-hook-form"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import InformationCollection from "./steps/InformationCollection"
import IssuerInformation from "./steps/IssuerInformation"
import PricingAgentInformation from "./steps/PricingAgentInformation"
import ReviewAndSubmit from "./steps/ReviewAndSubmit"
import WarningModal from "./WarningModal"
import FormErrorModal from "./FormErrorModal"

const RegistrationWizard = () => {
  const [isModalOpen, setModalOpen] = useState(true)
  const [isValidationModalOpen, setValidationModalOpen] = useState(false)

  const defaultValues = {
    isMPID: false,
    isPricingAgent: false,
    isFundIssuer: false,
    terms: false
  }
  const methods = useForm({
    defaultValues,
    mode: "onChange"
  })

  return (
    <>
      <WarningModal
        setModalOpen={() => {
          setModalOpen(false)
        }}
        isModalOpen={isModalOpen}
      />
      <FormProvider {...methods}>
        <form>
          <Wizard>
            <InformationCollection />
            <PricingAgentInformation />
            <IssuerInformation />
            <GoogleReCaptchaProvider
              useEnterprise
              reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY as string}
              container={{
                element: "recaptchav3",
                parameters: {
                  badge: "inline"
                }
              }}
            >
              <ReviewAndSubmit setValidationModalOpen={setValidationModalOpen} />
            </GoogleReCaptchaProvider>
          </Wizard>
        </form>
      </FormProvider>
      <FormErrorModal
        setValidationModalOpen={() => {
          setValidationModalOpen(false)
        }}
        isValidationModalOpen={isValidationModalOpen}
      />
    </>
  )
}

export default RegistrationWizard
